import { useEffect, useState } from "react"
import { initSentry } from "@/helpers/sentry"
import { dropForeignTelegramSession } from "@/helpers/tgSession"
import { initTelegramData } from "./utils/initTelegramData"

/**
 * A throwing step must never block `setIsInit`: AppShell renders nothing until
 * it, and the ErrorBoundary sits below that gate.
 */
const runBootstrapStep = (label: string, step: () => void) => {
  try {
    step()
  } catch (error) {
    console.warn(`[app-init] ${label} failed`, error)
  }
}

export const useAppInit = () => {
  const [isInit, setIsInit] = useState(false)

  useEffect(() => {
    runBootstrapStep("sentry", initSentry)
    runBootstrapStep("telegram", initTelegramData)
    runBootstrapStep("foreign-session guard", dropForeignTelegramSession)
    setIsInit(true)
    // Analytics provider is undecided (spec §10) — telegramAnalytics.init() would
    // go here once a provider + token are configured.
  }, [])

  return { isInit }
}
